/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as PlannerRouteImport } from './routes/planner'
import { Route as PowerUpsRouteImport } from './routes/power-ups'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as BoardInvitesTokenRouteImport } from './routes/board-invites.$token'
import { Route as MyCardsRouteImport } from './routes/my.cards'
import { Route as PowerUpsPowerUpIdRouteImport } from './routes/power-ups.$powerUpId'
import { Route as UsersUserIdRouteImport } from './routes/users.$userId'
import { Route as WorkspaceViewsViewIdRouteImport } from './routes/workspace-views.$viewId'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin.users.$userId'
import { Route as BShortLinkChar123SlugChar125RouteImport } from './routes/b.$shortLink.{-$slug}'
import { Route as CShortLinkChar123SlugChar125RouteImport } from './routes/c.$shortLink.{-$slug}'
import { Route as EmbedCardsCardIdRouteImport } from './routes/embed.cards.$cardId'
import { Route as EnterprisesEnterpriseIdPolicyRouteImport } from './routes/enterprises.$enterpriseId.policy'
import { Route as EnterprisesEnterpriseIdPowerUpsRouteImport } from './routes/enterprises.$enterpriseId.power-ups'
import { Route as WWorkspaceIdActivityRouteImport } from './routes/w.$workspaceId.activity'
import { Route as WWorkspaceIdCalendarRouteImport } from './routes/w.$workspaceId.calendar'
import { Route as WWorkspaceIdMembersRouteImport } from './routes/w.$workspaceId.members'
import { Route as WWorkspaceIdTableRouteImport } from './routes/w.$workspaceId.table'
import { Route as WWorkspaceIdViewsRouteImport } from './routes/w.$workspaceId.views'
import { Route as CShortLinkComNumberRouteImport } from './routes/c.$shortLink.com.$number'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const PlannerRoute = PlannerRouteImport.update({
  id: '/planner',
  path: '/planner',
  getParentRoute: () => rootRouteImport,
} as any)
const PowerUpsRoute = PowerUpsRouteImport.update({
  id: '/power-ups',
  path: '/power-ups',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRoute = TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardInvitesTokenRoute = BoardInvitesTokenRouteImport.update({
  id: '/board-invites/$token',
  path: '/board-invites/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const MyCardsRoute = MyCardsRouteImport.update({
  id: '/my/cards',
  path: '/my/cards',
  getParentRoute: () => rootRouteImport,
} as any)
const PowerUpsPowerUpIdRoute = PowerUpsPowerUpIdRouteImport.update({
  id: '/$powerUpId',
  path: '/$powerUpId',
  getParentRoute: () => PowerUpsRoute,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceViewsViewIdRoute = WorkspaceViewsViewIdRouteImport.update({
  id: '/workspace-views/$viewId',
  path: '/workspace-views/$viewId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AdminRoute,
} as any)
const BShortLinkChar123SlugChar125Route =
  BShortLinkChar123SlugChar125RouteImport.update({
    id: '/b/$shortLink/{-$slug}',
    path: '/b/$shortLink/{-$slug}',
    getParentRoute: () => rootRouteImport,
  } as any)
const CShortLinkChar123SlugChar125Route =
  CShortLinkChar123SlugChar125RouteImport.update({
    id: '/c/$shortLink/{-$slug}',
    path: '/c/$shortLink/{-$slug}',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmbedCardsCardIdRoute = EmbedCardsCardIdRouteImport.update({
  id: '/embed/cards/$cardId',
  path: '/embed/cards/$cardId',
  getParentRoute: () => rootRouteImport,
} as any)
const EnterprisesEnterpriseIdPolicyRoute =
  EnterprisesEnterpriseIdPolicyRouteImport.update({
    id: '/enterprises/$enterpriseId/policy',
    path: '/enterprises/$enterpriseId/policy',
    getParentRoute: () => rootRouteImport,
  } as any)
const EnterprisesEnterpriseIdPowerUpsRoute =
  EnterprisesEnterpriseIdPowerUpsRouteImport.update({
    id: '/enterprises/$enterpriseId/power-ups',
    path: '/enterprises/$enterpriseId/power-ups',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdActivityRoute = WWorkspaceIdActivityRouteImport.update({
  id: '/w/$workspaceId/activity',
  path: '/w/$workspaceId/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdCalendarRoute = WWorkspaceIdCalendarRouteImport.update({
  id: '/w/$workspaceId/calendar',
  path: '/w/$workspaceId/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdMembersRoute = WWorkspaceIdMembersRouteImport.update({
  id: '/w/$workspaceId/members',
  path: '/w/$workspaceId/members',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdTableRoute = WWorkspaceIdTableRouteImport.update({
  id: '/w/$workspaceId/table',
  path: '/w/$workspaceId/table',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdViewsRoute = WWorkspaceIdViewsRouteImport.update({
  id: '/w/$workspaceId/views',
  path: '/w/$workspaceId/views',
  getParentRoute: () => rootRouteImport,
} as any)
const CShortLinkComNumberRoute = CShortLinkComNumberRouteImport.update({
  id: '/c/$shortLink/com/$number',
  path: '/c/$shortLink/com/$number',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/inbox': typeof InboxRoute
  '/planner': typeof PlannerRoute
  '/power-ups': typeof PowerUpsRouteWithChildren
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/sign-in': typeof SignInRoute
  '/templates': typeof TemplatesRoute
  '/board-invites/$token': typeof BoardInvitesTokenRoute
  '/my/cards': typeof MyCardsRoute
  '/power-ups/$powerUpId': typeof PowerUpsPowerUpIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/workspace-views/$viewId': typeof WorkspaceViewsViewIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/b/$shortLink/{-$slug}': typeof BShortLinkChar123SlugChar125Route
  '/c/$shortLink/{-$slug}': typeof CShortLinkChar123SlugChar125Route
  '/embed/cards/$cardId': typeof EmbedCardsCardIdRoute
  '/enterprises/$enterpriseId/policy': typeof EnterprisesEnterpriseIdPolicyRoute
  '/enterprises/$enterpriseId/power-ups': typeof EnterprisesEnterpriseIdPowerUpsRoute
  '/w/$workspaceId/activity': typeof WWorkspaceIdActivityRoute
  '/w/$workspaceId/calendar': typeof WWorkspaceIdCalendarRoute
  '/w/$workspaceId/members': typeof WWorkspaceIdMembersRoute
  '/w/$workspaceId/table': typeof WWorkspaceIdTableRoute
  '/w/$workspaceId/views': typeof WWorkspaceIdViewsRoute
  '/c/$shortLink/com/$number': typeof CShortLinkComNumberRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/inbox': typeof InboxRoute
  '/planner': typeof PlannerRoute
  '/power-ups': typeof PowerUpsRouteWithChildren
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/sign-in': typeof SignInRoute
  '/templates': typeof TemplatesRoute
  '/board-invites/$token': typeof BoardInvitesTokenRoute
  '/my/cards': typeof MyCardsRoute
  '/power-ups/$powerUpId': typeof PowerUpsPowerUpIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/workspace-views/$viewId': typeof WorkspaceViewsViewIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/b/$shortLink/{-$slug}': typeof BShortLinkChar123SlugChar125Route
  '/c/$shortLink/{-$slug}': typeof CShortLinkChar123SlugChar125Route
  '/embed/cards/$cardId': typeof EmbedCardsCardIdRoute
  '/enterprises/$enterpriseId/policy': typeof EnterprisesEnterpriseIdPolicyRoute
  '/enterprises/$enterpriseId/power-ups': typeof EnterprisesEnterpriseIdPowerUpsRoute
  '/w/$workspaceId/activity': typeof WWorkspaceIdActivityRoute
  '/w/$workspaceId/calendar': typeof WWorkspaceIdCalendarRoute
  '/w/$workspaceId/members': typeof WWorkspaceIdMembersRoute
  '/w/$workspaceId/table': typeof WWorkspaceIdTableRoute
  '/w/$workspaceId/views': typeof WWorkspaceIdViewsRoute
  '/c/$shortLink/com/$number': typeof CShortLinkComNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/inbox': typeof InboxRoute
  '/planner': typeof PlannerRoute
  '/power-ups': typeof PowerUpsRouteWithChildren
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/sign-in': typeof SignInRoute
  '/templates': typeof TemplatesRoute
  '/board-invites/$token': typeof BoardInvitesTokenRoute
  '/my/cards': typeof MyCardsRoute
  '/power-ups/$powerUpId': typeof PowerUpsPowerUpIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/workspace-views/$viewId': typeof WorkspaceViewsViewIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/b/$shortLink/{-$slug}': typeof BShortLinkChar123SlugChar125Route
  '/c/$shortLink/{-$slug}': typeof CShortLinkChar123SlugChar125Route
  '/embed/cards/$cardId': typeof EmbedCardsCardIdRoute
  '/enterprises/$enterpriseId/policy': typeof EnterprisesEnterpriseIdPolicyRoute
  '/enterprises/$enterpriseId/power-ups': typeof EnterprisesEnterpriseIdPowerUpsRoute
  '/w/$workspaceId/activity': typeof WWorkspaceIdActivityRoute
  '/w/$workspaceId/calendar': typeof WWorkspaceIdCalendarRoute
  '/w/$workspaceId/members': typeof WWorkspaceIdMembersRoute
  '/w/$workspaceId/table': typeof WWorkspaceIdTableRoute
  '/w/$workspaceId/views': typeof WWorkspaceIdViewsRoute
  '/c/$shortLink/com/$number': typeof CShortLinkComNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/inbox'
    | '/planner'
    | '/power-ups'
    | '/profile'
    | '/search'
    | '/sign-in'
    | '/templates'
    | '/board-invites/$token'
    | '/my/cards'
    | '/power-ups/$powerUpId'
    | '/users/$userId'
    | '/workspace-views/$viewId'
    | '/admin/users/$userId'
    | '/b/$shortLink/{-$slug}'
    | '/c/$shortLink/{-$slug}'
    | '/embed/cards/$cardId'
    | '/enterprises/$enterpriseId/policy'
    | '/enterprises/$enterpriseId/power-ups'
    | '/w/$workspaceId/activity'
    | '/w/$workspaceId/calendar'
    | '/w/$workspaceId/members'
    | '/w/$workspaceId/table'
    | '/w/$workspaceId/views'
    | '/c/$shortLink/com/$number'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/inbox'
    | '/planner'
    | '/power-ups'
    | '/profile'
    | '/search'
    | '/sign-in'
    | '/templates'
    | '/board-invites/$token'
    | '/my/cards'
    | '/power-ups/$powerUpId'
    | '/users/$userId'
    | '/workspace-views/$viewId'
    | '/admin/users/$userId'
    | '/b/$shortLink/{-$slug}'
    | '/c/$shortLink/{-$slug}'
    | '/embed/cards/$cardId'
    | '/enterprises/$enterpriseId/policy'
    | '/enterprises/$enterpriseId/power-ups'
    | '/w/$workspaceId/activity'
    | '/w/$workspaceId/calendar'
    | '/w/$workspaceId/members'
    | '/w/$workspaceId/table'
    | '/w/$workspaceId/views'
    | '/c/$shortLink/com/$number'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/inbox'
    | '/planner'
    | '/power-ups'
    | '/profile'
    | '/search'
    | '/sign-in'
    | '/templates'
    | '/board-invites/$token'
    | '/my/cards'
    | '/power-ups/$powerUpId'
    | '/users/$userId'
    | '/workspace-views/$viewId'
    | '/admin/users/$userId'
    | '/b/$shortLink/{-$slug}'
    | '/c/$shortLink/{-$slug}'
    | '/embed/cards/$cardId'
    | '/enterprises/$enterpriseId/policy'
    | '/enterprises/$enterpriseId/power-ups'
    | '/w/$workspaceId/activity'
    | '/w/$workspaceId/calendar'
    | '/w/$workspaceId/members'
    | '/w/$workspaceId/table'
    | '/w/$workspaceId/views'
    | '/c/$shortLink/com/$number'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  InboxRoute: typeof InboxRoute
  PlannerRoute: typeof PlannerRoute
  PowerUpsRoute: typeof PowerUpsRouteWithChildren
  ProfileRoute: typeof ProfileRoute
  SearchRoute: typeof SearchRoute
  SignInRoute: typeof SignInRoute
  TemplatesRoute: typeof TemplatesRoute
  BoardInvitesTokenRoute: typeof BoardInvitesTokenRoute
  MyCardsRoute: typeof MyCardsRoute
  UsersUserIdRoute: typeof UsersUserIdRoute
  WorkspaceViewsViewIdRoute: typeof WorkspaceViewsViewIdRoute
  BShortLinkChar123SlugChar125Route: typeof BShortLinkChar123SlugChar125Route
  CShortLinkChar123SlugChar125Route: typeof CShortLinkChar123SlugChar125Route
  EmbedCardsCardIdRoute: typeof EmbedCardsCardIdRoute
  EnterprisesEnterpriseIdPolicyRoute: typeof EnterprisesEnterpriseIdPolicyRoute
  EnterprisesEnterpriseIdPowerUpsRoute: typeof EnterprisesEnterpriseIdPowerUpsRoute
  WWorkspaceIdActivityRoute: typeof WWorkspaceIdActivityRoute
  WWorkspaceIdCalendarRoute: typeof WWorkspaceIdCalendarRoute
  WWorkspaceIdMembersRoute: typeof WWorkspaceIdMembersRoute
  WWorkspaceIdTableRoute: typeof WWorkspaceIdTableRoute
  WWorkspaceIdViewsRoute: typeof WWorkspaceIdViewsRoute
  CShortLinkComNumberRoute: typeof CShortLinkComNumberRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planner': {
      id: '/planner'
      path: '/planner'
      fullPath: '/planner'
      preLoaderRoute: typeof PlannerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/power-ups': {
      id: '/power-ups'
      path: '/power-ups'
      fullPath: '/power-ups'
      preLoaderRoute: typeof PowerUpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/board-invites/$token': {
      id: '/board-invites/$token'
      path: '/board-invites/$token'
      fullPath: '/board-invites/$token'
      preLoaderRoute: typeof BoardInvitesTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/cards': {
      id: '/my/cards'
      path: '/my/cards'
      fullPath: '/my/cards'
      preLoaderRoute: typeof MyCardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/power-ups/$powerUpId': {
      id: '/power-ups/$powerUpId'
      path: '/$powerUpId'
      fullPath: '/power-ups/$powerUpId'
      preLoaderRoute: typeof PowerUpsPowerUpIdRouteImport
      parentRoute: typeof PowerUpsRoute
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace-views/$viewId': {
      id: '/workspace-views/$viewId'
      path: '/workspace-views/$viewId'
      fullPath: '/workspace-views/$viewId'
      preLoaderRoute: typeof WorkspaceViewsViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/b/$shortLink/{-$slug}': {
      id: '/b/$shortLink/{-$slug}'
      path: '/b/$shortLink/{-$slug}'
      fullPath: '/b/$shortLink/{-$slug}'
      preLoaderRoute: typeof BShortLinkChar123SlugChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$shortLink/{-$slug}': {
      id: '/c/$shortLink/{-$slug}'
      path: '/c/$shortLink/{-$slug}'
      fullPath: '/c/$shortLink/{-$slug}'
      preLoaderRoute: typeof CShortLinkChar123SlugChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/cards/$cardId': {
      id: '/embed/cards/$cardId'
      path: '/embed/cards/$cardId'
      fullPath: '/embed/cards/$cardId'
      preLoaderRoute: typeof EmbedCardsCardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enterprises/$enterpriseId/policy': {
      id: '/enterprises/$enterpriseId/policy'
      path: '/enterprises/$enterpriseId/policy'
      fullPath: '/enterprises/$enterpriseId/policy'
      preLoaderRoute: typeof EnterprisesEnterpriseIdPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enterprises/$enterpriseId/power-ups': {
      id: '/enterprises/$enterpriseId/power-ups'
      path: '/enterprises/$enterpriseId/power-ups'
      fullPath: '/enterprises/$enterpriseId/power-ups'
      preLoaderRoute: typeof EnterprisesEnterpriseIdPowerUpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/activity': {
      id: '/w/$workspaceId/activity'
      path: '/w/$workspaceId/activity'
      fullPath: '/w/$workspaceId/activity'
      preLoaderRoute: typeof WWorkspaceIdActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/calendar': {
      id: '/w/$workspaceId/calendar'
      path: '/w/$workspaceId/calendar'
      fullPath: '/w/$workspaceId/calendar'
      preLoaderRoute: typeof WWorkspaceIdCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/members': {
      id: '/w/$workspaceId/members'
      path: '/w/$workspaceId/members'
      fullPath: '/w/$workspaceId/members'
      preLoaderRoute: typeof WWorkspaceIdMembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/table': {
      id: '/w/$workspaceId/table'
      path: '/w/$workspaceId/table'
      fullPath: '/w/$workspaceId/table'
      preLoaderRoute: typeof WWorkspaceIdTableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/views': {
      id: '/w/$workspaceId/views'
      path: '/w/$workspaceId/views'
      fullPath: '/w/$workspaceId/views'
      preLoaderRoute: typeof WWorkspaceIdViewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$shortLink/com/$number': {
      id: '/c/$shortLink/com/$number'
      path: '/c/$shortLink/com/$number'
      fullPath: '/c/$shortLink/com/$number'
      preLoaderRoute: typeof CShortLinkComNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteChildren {
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface PowerUpsRouteChildren {
  PowerUpsPowerUpIdRoute: typeof PowerUpsPowerUpIdRoute
}

const PowerUpsRouteChildren: PowerUpsRouteChildren = {
  PowerUpsPowerUpIdRoute: PowerUpsPowerUpIdRoute,
}

const PowerUpsRouteWithChildren = PowerUpsRoute._addFileChildren(
  PowerUpsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  InboxRoute: InboxRoute,
  PlannerRoute: PlannerRoute,
  PowerUpsRoute: PowerUpsRouteWithChildren,
  ProfileRoute: ProfileRoute,
  SearchRoute: SearchRoute,
  SignInRoute: SignInRoute,
  TemplatesRoute: TemplatesRoute,
  BoardInvitesTokenRoute: BoardInvitesTokenRoute,
  MyCardsRoute: MyCardsRoute,
  UsersUserIdRoute: UsersUserIdRoute,
  WorkspaceViewsViewIdRoute: WorkspaceViewsViewIdRoute,
  BShortLinkChar123SlugChar125Route: BShortLinkChar123SlugChar125Route,
  CShortLinkChar123SlugChar125Route: CShortLinkChar123SlugChar125Route,
  EmbedCardsCardIdRoute: EmbedCardsCardIdRoute,
  EnterprisesEnterpriseIdPolicyRoute: EnterprisesEnterpriseIdPolicyRoute,
  EnterprisesEnterpriseIdPowerUpsRoute: EnterprisesEnterpriseIdPowerUpsRoute,
  WWorkspaceIdActivityRoute: WWorkspaceIdActivityRoute,
  WWorkspaceIdCalendarRoute: WWorkspaceIdCalendarRoute,
  WWorkspaceIdMembersRoute: WWorkspaceIdMembersRoute,
  WWorkspaceIdTableRoute: WWorkspaceIdTableRoute,
  WWorkspaceIdViewsRoute: WWorkspaceIdViewsRoute,
  CShortLinkComNumberRoute: CShortLinkComNumberRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
